/* ===========================
   AUTH HELPERS
=========================== */

export const getToken = () => {
  const token = localStorage.getItem("token");
  if (!token || token === "undefined") return null;
  return token;
};

export const getLoggedInUser = () => {
  try {
    const userStr = localStorage.getItem("user");

    if (!userStr || userStr === "undefined") {
      return null;
    }

    return JSON.parse(userStr);
  } catch (err) {
    console.error("Invalid user in storage:", err);
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.href = "/";
};

export const isAuthenticated = () => {
  return !!getLoggedInUser();
};
